export default __webpack_public_path__ + "static/media/nabua.dd618b33.jpg";